import PropTypes from "prop-types";

/**
 * Mobile list/detail page chrome (card + padding). Transparent on lg+ so desktop layouts stay unchanged.
 */
function PageContentShell({ children, className = "" }) {
    return (
        <div
            className={`flex min-w-0 flex-col gap-4 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-gray-100 sm:p-5 lg:gap-0 lg:rounded-none lg:bg-transparent lg:p-0 lg:shadow-none lg:ring-0 ${className}`.trim()}>
            {children}
        </div>
    );
}

PageContentShell.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default PageContentShell;
